<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="6">
        <b-form @reload="reload" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model="form.keyword"
              :placeholder="
                $l('plan_label_search') || '面料计划编号/订单编码搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
      <el-dialog
        :title="$l('INDEX.advanced_search') || '高级搜索'"
        :show-close="true"
        :visible.sync="advqueryDialogVisible"
        width="750px"
        :close-on-click-modal="false"
      >
        <el-form
          ref="form"
          :model="form"
          label-position="right"
          label-width="130px"
          size="small"
        >
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_mrpFabricPlanNo') || '面料计划编号'"
              >
                <el-input
                  v-model.trim="form.mrpFabricPlanNo"
                  clearable
                  size="small"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.order_form_label_orderNo') || '订单编码'"
              >
                <el-input v-model.trim="form.orderNo" clearable size="small">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item :label="$l('INDEX.create_date') || '创建时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginCreateDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endCreateDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item :label="$l('INDEX.table_label_modification_date') || '修改时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginModifyDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endModifyDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item :label="$l('form_label_reviewDate') || '审核时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginReviewDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endReviewDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="24">
              <el-col :span="24">
                <el-form-item
                  :label="$l('form_label_planStatus') || '订单状态'"
                >
                  <dict-select
                    multiple
                    clearable
                    filterable
                    v-model="form.planStatusList"
                    :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                    size="small"
                    url="/sys/common/dict/system"
                    :body="{dictType: 'planStatus'}"
                  ></dict-select>
                </el-form-item>
              </el-col>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="closeAdvqueryDialog">{{
            $l('INDEX.btn_cancel_query') || '取消查询'
          }}</el-button>
          <el-button size="small" type="warning" @click="reload">{{
            $l('INDEX.btn_reset_filter') || '重置条件'
          }}</el-button>
          <el-button size="small" type="primary" @click="advquery">{{
            $l('INDEX.btn_data_retrieval') || '数据检索'
          }}</el-button>
        </span>
      </el-dialog>
    </b-row>
  </div>
</template>

<script>
const initForm = {
  keyword: '',
  planStatusList: ['N', 'D', 'Y', 'P', 'T', 'C'],
}

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: {...initForm},
    }
  },
  created() {
    this.query()
  },
  methods: {
    //初始查询
    query({isReset = true} = {}) {
      if (isReset) {
        this.$emit('reload')
      }
      this.$emit('query', this.form)
    },
    //高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    //重置条件查询
    reload() {
      this.form = {...initForm}
    },
    //打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    //关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
